import { ActionTypes } from "../../constants/ActionTypes";
import { IAppointmentReducer } from "../../interfaces/Appointments";

const INIT_STATE: IAppointmentReducer = {
  appointments: [],
  appointmentCalendars: [],
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.GET_APPOINTMENTS_CALENDARS: {
      return {
        ...state,
      };
    }

    case ActionTypes.FETCH_APPOINTMENTS_CALENDARS_SUCCESS: {
      return {
        ...state,
        appointmentCalendars: action.payload,
      };
    }
    //******************************************
    case ActionTypes.GET_APPOINTMENTS: {
      return {
        ...state,
        getAppoinmentModel: action.payload,
      };
    }

    case ActionTypes.FETCH_APPOINTMENTS_SUCCESS: {
      return {
        ...state,
        appointments: action.payload,
      };
    }

    default:
      return state;
  }
};
